import { getToken, onMessage } from 'firebase/messaging';
import { messaging } from '../config/firebase';


const VAPID_KEY = 'BHogT4jziXQKPW8sz3UGy0WK4nT46_CufxYrkOcp72uXqKx2FXZ8EidY41XHJnbiVGrU-Ytxo620_Qsqja0a0Ao';

class FCMService {
  constructor() {
    this.isSupported = 'serviceWorker' in navigator && 'PushManager' in window;
    this.initializeServiceWorker();
  }

  async initializeServiceWorker() {
    if (!this.isSupported) return;
    
    try {
      // Register Firebase messaging service worker
      const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
      console.log('Firebase messaging service worker registered:', registration);
      
      // Wait for service worker to be ready
      await navigator.serviceWorker.ready;
      console.log('Firebase messaging service worker is ready');
    } catch (error) {
      console.error('Error registering Firebase messaging service worker:', error);
    }
  }

  async requestPermission() {
    if (!this.isSupported) {
      console.warn('Push notifications not supported in this browser');
      return false;
    }
    
    try {
      const permission = await Notification.requestPermission();
      console.log('Notification permission:', permission);
      return permission === 'granted';
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      return false;
    }
  }

  async getToken() {
    if (!this.isSupported) {
      console.warn('Push notifications not supported');
      return null;
    }
    
    try {
      // Ensure service worker is ready before getting token
      await navigator.serviceWorker.ready;
      
      const token = await getToken(messaging, { 
        vapidKey: VAPID_KEY,
        serviceWorkerRegistration: await navigator.serviceWorker.getRegistration('/firebase-messaging-sw.js')
      });
      console.log('FCM Token generated:', token);
      return token;
    } catch (error) {
      console.error('Error getting FCM token:', error);
      return null;
    }
  }

  onForegroundMessage(callback) {
    if (!this.isSupported) return;
    
    return onMessage(messaging, (payload) => {
      console.log('Foreground message received:', payload);
      
      // Show notification manually for foreground messages
      if (payload.notification) {
        this.showNotification(payload.notification);
      }
      
      callback(payload);
    });
  }

  showNotification(notification) {
    if (!this.isSupported || Notification.permission !== 'granted') return;

    const { title, body, icon } = notification;
    
    new Notification(title, {
      body,
      icon: icon || '/logo192.png',
      badge: '/logo192.png',
      tag: 'misas-notification',
      requireInteraction: true
    });
  }

  getDeviceInfo() {
    const userAgent = navigator.userAgent;
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    
    return {
      device_type: 'web',
      device_name: isMobile ? 'Mobile Browser' : 'Desktop Browser',
      app_version: '1.0.0',
      os_version: navigator.platform,
      browser: this.getBrowserName(),
      user_agent: userAgent
    };
  }

  getBrowserName() {
    const userAgent = navigator.userAgent;
    
    if (userAgent.includes('Chrome')) return 'Chrome';
    if (userAgent.includes('Firefox')) return 'Firefox';
    if (userAgent.includes('Safari')) return 'Safari';
    if (userAgent.includes('Edge')) return 'Edge';
    
    return 'Unknown';
  }

  getPermissionStatus() {
    if (!this.isSupported) return 'not-supported';
    return Notification.permission;
  }

  async getServiceWorkerStatus() {
    if (!this.isSupported) return { supported: false };
    
    try {
      const registration = await navigator.serviceWorker.getRegistration('/firebase-messaging-sw.js');
      return {
        supported: true,
        registered: !!registration,
        active: !!registration?.active,
        scope: registration?.scope,
        state: registration?.active?.state
      };
    } catch (error) {
      return {
        supported: true,
        registered: false,
        error: error.message
      };
    }
  }
}

export default new FCMService();